export const isDateAttribute = ({ type }) => type === "DATE";
export const isAttributeWithFilterOptions = ({ filter_options }) => !!(filter_options == null ? void 0 : filter_options.length);
export const isAttributeWithRelatedCollection = ({ related_collection }) => !!related_collection;
export const isCustomComponentFilter = ({ filter_component }) => !!filter_component;
